import axios from 'axios';
import qs from 'qs';
import ObjectKeyConverter from '../utils/object_key_converter';
import FormDataBuilder from '../utils/form_data_builder';

export default class HttpClient {
  constructor() {
    this.url = null;
    this.timeout = 20000;
    this.storageKey = '';

    this.axios = axios.create();
    this.axios.interceptors.response.use(response => response, (async (error) => {
      if (error.response && error.response.status === 401) {
        await this.signIn({
          email: process.env.VUE_APP_DEFAULT_SIGNIN_EMAIL,
          password: process.env.VUE_APP_DEFAULT_SIGNIN_PASSWORD,
        });

        const config = error.config;
        config.headers = this.buildSessionHeaders();

        return this.axios.request(config);
      } else {
        throw error;
      }
    }));
  }

  async get(url, params, headers) {
    this._log(`GET => ${url}`);
    params = ObjectKeyConverter.camelToSnake(params);
    const paramsSerializer = (params) => qs.stringify(params, { arrayFormat: 'brackets' });

    try {
      const response = await this.axios.get(
        url,
        {
          timeout: this.timeout,
          headers,
          params,
          paramsSerializer,
          responseType: 'json',
        },
      );
      this._log(`GET <= ${url}`);
      this._log(response);
      response.data = ObjectKeyConverter.snakeToCamel(response.data);
      return response;
    } catch (e) {
      this._log(e, 'error');
      throw e;
    }
  }

  async post(url, params, headers) {
    this._log(`POST => ${url}`);
    params = ObjectKeyConverter.camelToSnake(params);
    params = FormDataBuilder.toFormData(params);

    try {
      const response = await this.axios.post(
        url,
        params,
        { headers },
      );
      this._log(`POST <= ${url}`);
      this._log(response);
      response.data = ObjectKeyConverter.snakeToCamel(response.data);
      return response;
    } catch (e) {
      this._log(e, 'error');
      throw e;
    }
  }

  async put(url, params, headers) {
    this._log(`PUT => ${url}`);
    params = ObjectKeyConverter.camelToSnake(params);
    params = FormDataBuilder.toFormData(params);

    try {
      const response = await this.axios.put(
        url,
        params,
        { headers },
      );
      this._log(`PUT <= ${url}`);
      this._log(response);
      response.data = ObjectKeyConverter.snakeToCamel(response.data);
      return response;
    } catch (e) {
      this._log(e, 'error');
      throw e;
    }
  }

  async delete(url, headers) {
    this._log(`DELETE => ${url}`);

    try {
      const response = await this.axios.delete(
        url,
        { headers },
      );
      this._log(`DELETE <= ${url}`);
      this._log(response);
      response.data = ObjectKeyConverter.snakeToCamel(response.data);
      return response;
    } catch (e) {
      this._log(e, 'error');
      throw e;
    }
  }

  _log(message, level) {
    if (level === 'error') {
      this._logError(message);
    } else {
      this._logInfo(message);
    }
  }

  _logInfo(message) {
    if (message instanceof Object) {
      console.info(message);
    } else {
      console.info(`${this._logPrefix()} ${message}`);
    }
  }

  _logError(message) {
    if (message instanceof Object) {
      console.error(message);
    } else {
      console.error(`${this._logPrefix()} ${message}`);
    }
  }

  _logPrefix() {
    return `${this._logDate()} [API CLIENT]`;
  }

  _logDate() {
    const now = new Date();
    const year = now.getFullYear();
    const month = this._padZero(now.getMonth() + 1);
    const day = this._padZero(now.getDate());
    const hour = this._padZero(now.getHours());
    const minute = this._padZero(now.getMinutes());
    const second = this._padZero(now.getSeconds());

    return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
  }

  _padZero(value) {
    return value.toString().padStart(2, '0');
  }
}



// WEBPACK FOOTER //
// ./src/libs/api_client/http_client.js